import React, { useEffect, useState } from "react";
import { Map as MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Row } from "reactstrap";
import L from "leaflet";
import vermelho from "../../assets/img/vermelho.svg";
import verde from "../../assets/img/verde.svg";
import amarelo from "../../assets/img/amarelo.svg";
import piscina from "../../assets/img/piscina.png";
import pontoEstrategico from "../../assets/img/ponto.png";
import grandeArea from "../../assets/img/grandes_areas.png";
import imovelAbandonado from "../../assets/img/abandonado.png";
import controleBiologico from "../../assets/img/biologico.png";
import borracharia from "../../assets/img/borracharia.png";
import mosquito from "../../assets/img/mosquito.png";
import edlArmadilha from "../../assets/img/armadilha-edl.png";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";


delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const MapsLeaflet = ({
  dados = [],
  setor = [],
  title = "MAPA DE OVITRAMPAS",
  dadosPiscina = [],
  dadosPontoEstrategico = [],
  dadosGrandeArea = [],
  dadosImovelAbandonado = [],
  dadosControleBiologico = [],
  dadosBorracharia = [],
  dadosDengue = [],
  dadosArmadilha = [],
}) => {
  const [positionInit, setPositionInit] = useState([-18.918, -48.2766]);
  const [location, setLocation] = useState([]);
  const [tipo, setTipo] = useState("NR_OVOS_VIAVEIS_");
  const [tipoCount, setTipoCount] = useState("IA");
  const [position, setPosition] = useState(positionInit);
  const [search, setSearch] = useState("");
  const [zoom, setZoom] = useState(12);
  const [clickedMarker, setClickedMarker] = useState(null);
  const [exibirPiscina, setExibirPiscina] = useState(false);
  const [exibirPontoEstrategico, setExibirPontoEstrategico] = useState(false);
  const [exibirGrandeArea, setExibirGrandeArea] = useState(false);
  const [exibirImovelAbandonado, setExibirImovelAbandonado] = useState(false);
  const [exibirControleBiologico, setExibirControleBiologico] = useState(false);
  const [exibirBorracharia, setExibirBorracharia] = useState(false);
  const [exibirArmadilha, setExibirArmadilha] = useState(true);
  const [exibirOvitrampa, setExibirOvitrampa] = useState(true);
  const [pontosPiscina, setPontosPiscina] = useState([]);
  const [pontosEstrategicos, setPontosEstrategicos] = useState([]);
  const [pontosGrandeArea, setPontosGrandeArea] = useState([]);
  const [pontosImovelAbandonado, setPontosImovelAbandonado] = useState([]);
  const [pontosControleBiologico, setPontosControleBiologico] = useState([]);
  const [pontosBorracharia, setPontosBorracharia] = useState([]);
  const [pontosArmadilha, setPontosArmadilha] = useState([]);
  const [setorSelecionado, setSetorSelecionado] = useState('Teste');

  useEffect(() => {
    if (pontosPiscina.length == 0) {
      setPontosPiscina(dadosPiscina);
    }
  }, [dadosPiscina]);

  useEffect(() => {
    if (pontosEstrategicos.length == 0) {
      setPontosEstrategicos(dadosPontoEstrategico);
    }
  }, [dadosPontoEstrategico]);

  useEffect(() => {
    if (pontosGrandeArea.length == 0) {
      setPontosGrandeArea(dadosGrandeArea);
    }
  }, [dadosGrandeArea]);

  useEffect(() => {
    if (pontosImovelAbandonado.length == 0) {
      setPontosImovelAbandonado(dadosImovelAbandonado);
    }
  }, [dadosImovelAbandonado]);

  useEffect(() => {
    if (pontosControleBiologico.length == 0) {
      setPontosControleBiologico(dadosControleBiologico);
    }
  }, [dadosControleBiologico]);

  useEffect(() => {
    if (pontosBorracharia.length == 0) {
      setPontosBorracharia(dadosBorracharia);
    }
  }, [dadosBorracharia]);

  useEffect(() => {
    if (pontosArmadilha.length == 0) {
      setPontosArmadilha(dadosArmadilha);
    }
  }, [dadosArmadilha]);

  useEffect(() => {
    setLocation(dados);
  }, [dados]);

  const downloadExcel = () => {
      if (!dados.length) {
        Swal.fire("Sem dados", "Nenhuma ovitrampa disponível para download", "info");
        return;
      }
  
      // Convert data to worksheet
      const ws = XLSX.utils.json_to_sheet(dados);
      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Ovitrampas");
      // Download file
      XLSX.writeFile(wb, "Relatorio_ovitrampas.xlsx");
    };
  
  const exibirMarcadores = () => {
    setExibirPiscina(true);
    setExibirPontoEstrategico(true);
    setExibirGrandeArea(true);
    setExibirImovelAbandonado(true);
    setExibirControleBiologico(true);
    setExibirBorracharia(true);
  }

  const centralizar = () => {
    if (search.length > 0) {
      let ovitrampa = dados.find(
        (item) =>
          (item?.OID_OVITRAMPA?.toString().toLowerCase() ?? "") ===
          (search?.toString().toLowerCase() ?? "")
      );
      if (ovitrampa) {
        if (
          position[0] == ovitrampa.DS_LATITUDE &&
          position[1] == ovitrampa.DS_LONGITUDE
        ) {
          ovitrampa.DS_LATITUDE = ovitrampa.DS_LATITUDE + "1";
          ovitrampa.DS_LONGITUDE = ovitrampa.DS_LONGITUDE + "1";
        }

        setPosition([ovitrampa.DS_LATITUDE, ovitrampa.DS_LONGITUDE]);
        ovitrampa.DS_LATITUDE = ovitrampa.DS_LATITUDE + "1";
        ovitrampa.DS_LONGITUDE = ovitrampa.DS_LONGITUDE + "1";
        setPosition([ovitrampa.DS_LATITUDE, ovitrampa.DS_LONGITUDE]);
        setSetorSelecionado(ovitrampa.NM_SETOR);
        if (zoom == 16) {
          setZoom(17);
        } else {
          setZoom(16);
        }
        exibirMarcadores();

        //setClickedMarker(ovitrampa.OID_OVITRAMPA);
      } else {
        Swal.fire({
          title: "Atenção",
          text: "Ovitrampa não encontrada",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    }
  };

  useEffect(() => {
    const elements = document.getElementsByClassName(
      "leaflet-attribution-flag"
    );
    for (let element of elements) {
      element.style.setProperty("display", "none", "important");
    }
  }, []);
  const Vermelho = new L.Icon({
    iconUrl: vermelho,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const Amarelo = new L.Icon({
    iconUrl: amarelo,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });

  const EdlArmadilha = new L.Icon({
    iconUrl: edlArmadilha,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const Verde = new L.Icon({
    iconUrl: verde,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const iconPiscina = new L.Icon({
    iconUrl: piscina,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const PontoEstrategico = new L.Icon({
    iconUrl: pontoEstrategico,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const GrandeArea = new L.Icon({
    iconUrl: grandeArea,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const ImovelAbandonado = new L.Icon({
    iconUrl: imovelAbandonado,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const ControleBiologico = new L.Icon({
    iconUrl: controleBiologico,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });
  const Borracharia = new L.Icon({
    iconUrl: borracharia,
    iconSize: [32, 42],
    iconAnchor: [8, 16],
    popupAnchor: [0, -16],
  });

   const downloadCSV = () => {
    if (!dados.length) {
      Swal.fire("Sem dados", "Nenhuma ovitrampa disponível para download", "info");
      return;
    }
    const header = Object.keys(dados[0]);
    const csv = [
      header.join(";"),
      ...dados.map((row) => header.map((h) => JSON.stringify(row[h] ?? "")).join(";")),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "ovitrampas.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const setorMap = setor.reduce((acc, item) => {
    acc[item.NM_SETOR] = item;
    return acc;
  }, {});

  return (
    <React.Fragment>
      <Row>
        <div
          style={{
            top: "-18px",
            width: "100vw",
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              display: "inline-block",
            }}
          >
            {title}
          </h1>

          <select
            value={tipoCount}
            onChange={(e) => setTipoCount(e.target.value)}
            style={{
              textAlign: "left",
              position: "absolute",
              left: "70px",
              top: "10px",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              border: "1px solid #ccc",
            }}
          >
            <option value="IA">Contagem por IA</option>
            <option value="LAB">Contagem Laboratorial</option>
          </select>
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            style={{
              textAlign: "left",
              position: "absolute",
              left: "70px",
              top: "60px",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              border: "1px solid #ccc",
            }}
          >
            <option value="NR_OVOS_VIAVEIS_">Ovos Dengue</option>
            {/* <option value="NR_OVOS_INVIAVEIS_">Ovos inviáveis</option> */}
            <option value="NR_OVOS_ECLODIDOS_">Ovos Eclodidos</option>
          </select>

          <details
            style={{
              position: "absolute",
              left: "70px",
              top: "110px",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            <summary style={{ fontWeight: "bold" }}>Tipos de Marcadores</summary>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                marginTop: "10px",
              }}
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirArmadilha}
                  onChange={() => setExibirArmadilha(!exibirArmadilha)}
                />{" "}
                Armadilhas
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirBorracharia}
                  onChange={() => setExibirBorracharia(!exibirBorracharia)}
                />{" "}
                Borracharias
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirControleBiologico}
                  onChange={() =>
                    setExibirControleBiologico(!exibirControleBiologico)
                  }
                />{" "}
                Controle Biológico
              </label>
                            <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirGrandeArea}
                  onChange={() => setExibirGrandeArea(!exibirGrandeArea)}
                />{" "}
                Grandes Áreas
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirImovelAbandonado}
                  onChange={() =>
                    setExibirImovelAbandonado(!exibirImovelAbandonado)
                  }
                />{" "}
                Imóveis Abandonados
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirOvitrampa}
                  onChange={() => setExibirOvitrampa(!exibirOvitrampa)}
                />{" "}
                Ovitrampas
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirPiscina}
                  onChange={() => setExibirPiscina(!exibirPiscina)}
                />{" "}
                Piscinas
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibirPontoEstrategico}
                  onChange={() =>
                    setExibirPontoEstrategico(!exibirPontoEstrategico)
                  }
                />{" "}
                Pontos Estratégicos
              </label>

              

            </div>
          </details>

            <button
            onClick={downloadExcel}
            style={{
              position: "absolute",
              right: "20px",
              top: "65px",
              zIndex: 1001,
              backgroundColor: "#46a571ff",
              color: "white",
              border: "none",
              padding: "8px 15px",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            ⬇️ Baixar Excel
          </button>

          <input
            // type="number"
            placeholder="Pesquisar ovitrampa..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                centralizar();
              }
            }}
            style={{
              position: "absolute",
              right: "180px",
              top: "20px",
              zIndex: 1001,
              backgroundColor: "rgba(255,255,255,0.8)",
              padding: "8px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "200px",
            }}
          />
          <button
            style={{
              position: "absolute",
              right: "130px",
              top: "20px",
              zIndex: 1001,
              backgroundColor: "rgb(24 202 255 / 38%)",
              padding: "8px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            onClick={() => centralizar()}
          >
            <i className="fas fa-search"></i>
          </button>
          <MapContainer
            center={position}
            zoom={zoom}
            style={{ height: "100vh", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {/** Localização das Ovitrampas */}
            {exibirOvitrampa && location?.map((data, key) => (
              <Marker
                key={data.OID_OVITRAMPA ?? key}
                ref={(ref) => {
                  if (clickedMarker === data.OID_OVITRAMPA && ref) {
                    ref.leafletElement.openPopup();
                  }
                }}
                position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                icon={
                  data.TP_SITUACAO === "VERMELHO"
                    ? Vermelho
                    : data.TP_SITUACAO === "AMARELO"
                    ? Amarelo
                    : Verde
                }
              >
                {
                  <Popup
                    onClose={() => {
                      setClickedMarker(null);
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        backgroundColor: "#fff",
                        padding: "15px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        minWidth: "300px",
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "2px solid #eee",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        <strong style={{ color: "#2c3e50" }}>
                          Cód. Ovitrampa:{" "}
                        </strong>
                        <span>{data.CD_CODIGO}</span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>
                          Responsável:{" "}
                        </strong>
                        <span>{data.NM_USUARIO}</span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>Situação: </strong>
                        <span
                          style={{
                            color:
                              data.TP_SITUACAO === "VERMELHO"
                                ? "#e74c3c"
                                : data.TP_SITUACAO === "AMARELO"
                                ? "#f1c40f"
                                : "#2ecc71",
                            fontWeight: "bold",
                          }}
                        >
                          {data.TP_SITUACAO}
                        </span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                        <span>{data.NM_SETOR}</span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>Endereço: </strong>
                        <span>{data.NM_LOGRADOURO}</span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>Número: </strong>
                        <span>{data.NR_NUMERO}</span>
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                        <span>{data.NM_BAIRRO}</span>
                      </div>

                    
                      <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>
                          Armadilhas (EDL):{" "}
                        </strong>
                        <span>{data.CD_CODIGO_EDL ? data.CD_CODIGO_EDL : "Nenhuma EDL vinculada"}</span>
                          
                      </div>
                        <div style={{ marginBottom: "8px" }}>
                        <strong style={{ color: "#2c3e50" }}>
                          Numero de ovos:{" "}
                        
                        <span>{data[tipo + tipoCount]}</span>
                        </strong>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          borderRadius: "6px",
                          marginTop: "10px",
                        }}
                      >
                        <strong style={{ color: "#e74c3c" }}>
                          Casos de dengue no setor: <br></br>
                          No Dia {dadosDengue.day[data.NM_SETOR]} Casos<br></br>
                          No Mês {dadosDengue.month[data.NM_SETOR]} Casos
                          <br></br>
                          No Ano {dadosDengue.year[data.NM_SETOR]} Casos
                        </strong>
                        <img
                          src={mosquito}
                          alt="Mosquito"
                          style={{
                            width: "30px",
                            height: "30px",
                            filter: "opacity(0.8)",
                          }}
                        />
                      </div>
                    </div>
                  </Popup>
                }
              </Marker>
            ))}
            {exibirPiscina &&
              setorSelecionado &&
              pontosPiscina.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Pi" + ( data.OID_PISCINA ?? key)}
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={iconPiscina}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Piscina:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Responsável:{" "}
                          </strong>
                          <span>{data.NM_USUARIO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirPontoEstrategico &&
              setorSelecionado &&
              pontosEstrategicos.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Po"+
                      data.CD_CODIGO
                        ? data.CD_CODIGO
                        : data.OID_PONTO_ESTRATEGICO
                    }
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={PontoEstrategico}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Ponto Estratégico:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Responsável:{" "}
                          </strong>
                          <span>{data.NM_USUARIO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirGrandeArea &&
              setorSelecionado &&
              pontosGrandeArea.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Gr" + ( data.OID_IMOVEL ?? key)}
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={GrandeArea}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Grande Área:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirImovelAbandonado &&
              setorSelecionado &&
              pontosImovelAbandonado.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Im" + ( data.OID_IMOVEL ?? key)}
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={ImovelAbandonado}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Imóvel Abandonado:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirControleBiologico &&
              setorSelecionado &&
              pontosControleBiologico.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Co" +
                      data.CD_CODIGO
                        ? data.CD_CODIGO
                        : data.OID_CONTROLE_BIOLOGICO
                    }
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={ControleBiologico}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Controle Biológico:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Responsável:{" "}
                          </strong>
                          <span>{data.NM_USUARIO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirBorracharia &&
              setorSelecionado &&
              pontosBorracharia.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Bo" + ( data.OID_BORRACHARIA ?? key)}
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={Borracharia}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Borracharia:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Responsável:{" "}
                          </strong>
                          <span>{data.NM_USUARIO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
            {exibirArmadilha &&
              setorSelecionado &&
              pontosArmadilha.map((data, key) =>
                true == true? (
                  <Marker
                    key={"Ar" + ( data.OID_ARMADILHA ?? key)}
                    position={[data.DS_LATITUDE, data.DS_LONGITUDE]}
                    icon={EdlArmadilha}
                  >
                    <Popup>
                      <div
                        style={{
                          fontSize: "16px",
                          backgroundColor: "#fff",
                          padding: "15px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            N° Armadilha:{" "}
                          </strong>
                          <span>{data.CD_CODIGO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Responsável:{" "}
                          </strong>
                          <span>{data.NM_USUARIO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Setor: </strong>
                          <span>{data.NM_SETOR}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Bairro: </strong>
                          <span>{data.NM_BAIRRO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Endereço:{" "}
                          </strong>
                          <span>{data.NM_LOGRADOURO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>Número: </strong>
                          <span>{data.NR_NUMERO}</span>
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ color: "#2c3e50" }}>
                            Complemento:{" "}
                          </strong>
                          <span>{data.DS_COMPLEMENTO}</span>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ) : null
              )}
          </MapContainer>
        </div>

        <div
          style={{
            position: "fixed",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
            backgroundColor: "rgba(255,255,255,0.8)",
            padding: "15px 25px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <div>
              <strong>
                Central:{" "}
                {setorMap["CENTRAL"]
                  ? setorMap["CENTRAL"][tipo + tipoCount]
                  : 0}
              </strong>
            </div>
            <div>
              <strong>
                Norte:{" "}
                {setorMap["NORTE"] ? setorMap["NORTE"][tipo + tipoCount] : 0}
              </strong>
            </div>
            <div>
              <strong>
                Sul: {setorMap["SUL"] ? setorMap["SUL"][tipo + tipoCount] : 0}
              </strong>
            </div>
            <div>
              <strong>
                Leste:{" "}
                {setorMap["LESTE"] ? setorMap["LESTE"][tipo + tipoCount] : 0}
              </strong>
            </div>
            <div>
              <strong>
                Oeste:{" "}
                {setorMap["OESTE"] ? setorMap["OESTE"][tipo + tipoCount] : 0}
              </strong>
            </div>
            <div>
              <strong>
                Outros:{" "}
                {setorMap["OUTROS"] ? setorMap["OUTROS"][tipo + tipoCount] : 0}
              </strong>
            </div>
          </div>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default MapsLeaflet;
